import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router'
import {
  CmsService,
  RoutingConfigService,
  RoutingService,
  SemanticPathService
} from '@spartacus/core'
import { filter, map, switchMap, tap } from 'rxjs/operators'
import { mbCheckoutConfig } from '../config/mb-default-checkout-config'
import { MbConstants } from '../../shared/mb-constants'
import { ActiveCartService } from '@spartacus/cart/base/core'
import { of } from 'rxjs'

@Injectable({
  providedIn: 'root'
})
export class CheckoutPagesGuard implements CanActivate {

  private checkoutSteps = mbCheckoutConfig
  private requestedStep = 0
  private allowGuard = false
  constants = MbConstants

  constructor (protected router: Router,
               protected activeCartService: ActiveCartService,
               protected routingConfigService: RoutingConfigService,
               protected semanticPathService: SemanticPathService,
               protected routingService: RoutingService,
               protected cmsService: CmsService) {
  }

  canActivate (router: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    return this.routingService.getNextPageContext().pipe(
      switchMap(pageContext => pageContext ? this.cmsService.getPage(pageContext, true) : of(undefined)),
      tap(page => {
        this.requestedStep = this.getCheckoutStepFromStepUrl(page?.label)
        this.allowGuard = this.getCheckoutStepAllowGuardFromStepUrl(page?.label)
      }),
      switchMap(() => this.activeCartService.getActive()),
      filter(cart => !!Object.keys(cart).length || this.allowGuard),
      map(cart => {
        const statusId = cart?.checkoutStatus?.checkoutPageId
        const statusStep = this.getCheckoutStepFromStepId(statusId)
        if (statusStep < 0) {
          if (this.allowGuard) {
            return true
          } else if (statusId === this.constants.CHECKOUT_STEP_LOGIN) {
            return false
          } else {
            return this.router.parseUrl('/not-found')
          }
        } else if (this.requestedStep > statusStep) {
          // allowGuard allows a previous Confirmation Page to be rendered
          return this.allowGuard ? true : this.navigateTo(statusStep)
        } else {
          return true
        }
      })
    )
  }

  navigateTo (statusStep: number) {
    const routeName = this.checkoutSteps?.checkout?.steps?.find(step => step?.step === statusStep)?.routeName
    if (routeName) {
      return this.router.parseUrl(this.semanticPathService.get(routeName) || '')
    }
    return this.router.parseUrl('/')
  }

  getCheckoutStepAllowGuardFromStepUrl (requestedStepUrl?: string) {
    return this.checkoutSteps.checkout?.steps?.find(step =>
      requestedStepUrl && ('/' + this.getStepUrlFromStepRoute(step.routeName))?.startsWith(requestedStepUrl)
    )?.allowGuard || false
  }

  getCheckoutStepFromStepUrl (requestedStepUrl?: string) {
    return this.checkoutSteps.checkout?.steps?.find(step =>
      requestedStepUrl && ('/' + this.getStepUrlFromStepRoute(step.routeName))?.startsWith(requestedStepUrl))?.step || -1
  }

  getCheckoutStepFromStepId (requestedStepId?: string) {
    return this.checkoutSteps.checkout?.steps?.find(step => requestedStepId && requestedStepId === step.id)?.step || -1
  }

  getStepUrlFromStepRoute (stepRouteName: string) {
    return this.routingConfigService.getRouteConfig(stepRouteName)?.paths?.[0] || ''
  }
}
